import React, { useEffect } from "react"
import { Link } from "gatsby"
import Aos from "aos"
import "aos/dist/aos.css"
import ImageShow from "../ImageShow/showImage"
import * as style from "./flutterCaseStudy.module.css"
import SectionsTitle from "../../Common/new/SectionsTitle"

const HealthCareCaseStudy = () => {
  useEffect(() => {
    Aos.init({
      once: true,
    })
  }, [])

  return (
    <section className={style.healthCareCaseStudy}>
      <div className="container">
        <SectionsTitle
          title="Case studies"
          SubTitle="Our success stories"
          Content="We tailor software solutions to address the business challenges & needs of our clients."
          styleCss={{ display: "none" }}
        />
        <div className={style.caseStudyContent}>
          <div className={style.contentLeft}>
            <ImageShow
              imgTagClass={style.quoteImage}
              imageData={"/images/Rectangle 3021.png"}
              alt="person"
            />
          </div>
          <div className={style.contentRight}>
            <h2>Secure & reliable comprehensive healthcare portal.</h2>
            <p>Ivira</p>
            <p>
              Ivira is a custom web-based panel for the care managers and
              pharmacists and a separate web-based panel for the system
              administrator. The user panel allows pharmacists and care managers
              to add patient demographic details, assign care programs, and view
              patient readings.
            </p>
            <Link to="/case-studies/ivira/" className={style.caseStudyLink}>
              Read the case study
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}

export default HealthCareCaseStudy
